import React from "react";

import Hero from "./Hero";
import AboutServicesSection from "./AboutServicesSection";
import ProductSection from "./ProductSection";
import TestimonialsSection from "./TestimonialsSection";
import FrecuentQuestions from "./FrequentQuestions";
import FooterSprintCore from "../components/FooterSprintCore";
import ProjectsSection from "./ProjectsSection";

const Rutes: React.FC = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <main className="flex-1">
        <section id="hero">
          <Hero />
        </section>

        <section id="about">
          <AboutServicesSection />
        </section>

        <section id="services">
          <ProductSection />
        </section>

        <section id="proyects">
          <ProjectsSection />
        </section>

        <section id="qa">
          <TestimonialsSection />
        </section>

        <section id="questions">
          <FrecuentQuestions />
        </section>

        <section id="footer">
          <FooterSprintCore />
        </section>
      </main>
    </div>
  );
};

export default Rutes;
